Create a bounded local workspace:

  cofactor external-run debug materialize <run-id>

The default downloads run logs plus first-failure screenshots and DOM evidence
for failed/flaky scenarios. Video is excluded by default because it is large:

  --include-video
  --artifacts none|failures|all
  --out <directory>

The output directory must be new or empty; the command refuses to overwrite an
existing workspace.

Narrow the workspace when one scenario is under investigation:

  cofactor external-run debug materialize <run-id> --item <item-id-or-text>

The workspace contains summary.md, manifest.json, JSONL result rows, folded
scenarios, skip explanations, lifecycle telemetry, scenario histories,
diagnostics, and an artifact manifest. Downloads are best-effort: a retained row
whose artifact has expired is recorded as unavailable instead of aborting the
whole materialization.
